module.exports = __webpack_public_path__ + "static/media/jewelry2.a5936ff6.jpg";